import { takeLatest, put, call } from 'redux-saga/effects';

import { listPlantioManejo } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO,
  NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_PENDING,
  NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_PLANTIO_MANEJO } from '@commons/consts';

function* sagaNewFilterNextPagePlantioManejo(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const idSafraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva?.id ?? -1;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PLANTIO_MANEJO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PLANTIO_MANEJO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    let list = yield call(listPlantioManejo, idFazenda, idSafraAtiva, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);    

    sessionStorage.setItem(CONST_FILTER_PLANTIO_MANEJO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPagePlantioManejo() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PLANTIO_MANEJO, sagaNewFilterNextPagePlantioManejo)
}